
export const login = (login) => dispatch => {
  if(login)
  dispatch({
    type: 'LOGIN'
  })
  else
    dispatch({
      type:'LOGOUT'
    })

  return;
}

export const nextStage = () => dispatch => {
  dispatch({
    type: 'NEXT_STAGE'
  })
}

export const setProject = (project) => dispatch => {

  dispatch({
    type: 'SET_PROJECT',
    payload: project
  })
}

export const updateCurrentBet = (currentBet, betType, clearAction) => dispatch => {
  // console.log(betType, currentBet, clearAction);
  if (clearAction) {
    dispatch({
      type: 'CLEAR_SIDE_BET_TYPE',
    });
    return;
  }
  switch(betType){
    case 'Player':
      dispatch ({
        type: 'UPDATE_PLAYER_BET',
        payload: currentBet
      });
      break;
    case 'Banker':
      dispatch ({
        type: 'UPDATE_BANKER_BET',
        payload: currentBet
      });
      break;
    case 'Tie':
      dispatch ({
        type: 'UPDATE_TIE_BET',
        payload: currentBet
      });
      break;
    case 'Player Dragon':
      dispatch ({
        type: 'UPDATE_PLAYER_DRAGON_BETS',
        payload: currentBet
      });
      break;
    case 'Banker Dragon':
      dispatch ({
        type: 'UPDATE_BANKER_DRAGON_BETS',
        payload: currentBet
      });
      break;
    case 'Perfect Pair':
      dispatch ({
        type: 'UPDATE_PERFECT_PAIR_BETS',
        payload: currentBet
      })
    default:
      return;
  }
};

export const saveCards = (payload) => ({
  type: 'SAVE_CARDS',
  payload,
});

export const resetGameState = () => ({
  type: 'RESET_GAME_STATE'
});

export const saveResult = (payload) => ({
  type: 'SAVE_RESULT',
  payload,
});

export const saveSideBetResult = (payload) => ({
  type: 'SAVE_SIDEBET_RESULT',
  payload,
});

export const savePayout = (payload) => ({
  type: 'SAVE_PAYOUT',
  payload,
});

export const setTransactionInProgress = (payload) => ({
  type: 'SET_TRANSACTION_IN_PROGRESS',
  payload,
});

export const resetForRebet = () => ({
  type: 'RESET_FOR_REBET'
});

export const resetBalance = (balance) => ({
  type: 'RESET_BALANCE',
  payload: balance,
});

export const saveLastTenHands = (hands) => ({
  type: 'SAVE_LAST_TEN_HANDS',
  payload: hands,
});

export const setShowActionBtns = (payload) => ({
  type: 'SET_SHOW_ACTION_BTNS',
  payload,
});

export const resetAllBets = () => ({
  type: 'RESET_ALL_BETS'
});

export const setAutoBet = (payload) => ({
  type: 'SET_AUTO_BET',
  payload,
});

export const setSideBetBlink = (payload) => ({
  type: 'SET_SIDEBET_BLINK',
  payload,
});

export const showShuffleAnimation = (payload) => ({
  type: 'SHOW_SHUFFLE_ANIMATION',
  payload,
});

export const setWalletAddress = (payload) => ({
  type: 'SET_WALLET_ADDRESS',
  payload,
})

export const showBalanceModal = (payload) => ({
  type: 'SHOW_BALANCE_MODAL',
  payload,
})

export const resetSideBetBlink = () => ({
  type: 'RESET_SIDEBET_BLINK'
})